<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                $t('button.dismiss') }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ $t('button.confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="clientes" :mostrar-inativos="mostrarInativos" :loading="loadingtable"
            :default-multi-sort="defaultSort" :loading-text="$t('clients.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="CLIENTES" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('clients.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : clientesFiltrados" :csv-title="$t('clients.title')"
                    :pdf-title="$t('clients.title')" :pdf-headers="headers" :pdf-filename="$t('clients.title')" hide-search>
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $tc('clients.self', 1) }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.codigo_cliente" 
                                                        :label="$t('clients.headers.code')"
                                                        :rules="[(v) => !!v || $t('rules.messageCode')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.nome_cliente" 
                                                        :label="$t('clients.headers.name')"
                                                        :rules="[(v) => !!v || $t('rules.messageName')]"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select v-model="editedItem.id_empresa"
                                                        :label="$t('clients.headers.company')" 
                                                        :items="empresas"
                                                        item-text="razao_social"
                                                        item-value="id_empresa"
                                                        :rules="[(v) => !!v || $t('rules.messageCompany')]"></v-select>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-switch v-model="editedItem.ativo" 
                                                        :label="$t('clients.headers.active')"
                                                        color="primary"></v-switch>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <div class="text-subtitle-1 mb-2">{{ $t('clients.headers.locations') }}</div>
                                                    <v-radio-group v-model="defaultLocalKey" hide-details class="mt-0 pt-0" @change="onDefaultAddressChange">
                                                        <v-simple-table dense class="mb-3">
                                                            <template v-slot:default>
                                                                <thead>
                                                                    <tr>
                                                                        <th>{{ $t('clients.headers.locations') }}</th>
                                                                        <th>{{ $t('passengers.address.street') }} / {{ $t('passengers.address.city') }}</th>
                                                                        <th class="text-center">{{ $t('clients.defaultAddress') || 'Padrão' }}</th>
                                                                        <th class="text-center">{{ $t('clients.headers.active') }}</th>
                                                                        <th class="text-right" style="width: 100px;">{{ $t('clients.headers.actions') }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="local in addressesForTable" :key="local.id_local || local._pendingId">
                                                                        <td>{{ local.nome_local || '—' }}</td>
                                                                        <td>{{ formatAddressLine(local) }}</td>
                                                                        <td class="text-center">
                                                                            <v-radio :value="local.id_local || local._pendingId" :disabled="!(local.ativo === 1 || local.ativo === true) || !canEdit" />
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <v-chip v-if="local.ativo === 1 || local.ativo === true" small color="success" dark>{{ $t('clients.active') || 'Ativo' }}</v-chip>
                                                                            <v-chip v-else small color="grey">{{ $t('clients.inactive') || 'Inativo' }}</v-chip>
                                                                        </td>
                                                                        <td class="text-right">
                                                                            <v-btn v-if="local.ativo === 1 || local.ativo === true" x-small color="warning" @click="deactivateLocal(local)" :disabled="!canEdit">
                                                                                {{ $t('clients.deactivate') || 'Desativar' }}
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="!addressesForTable.length">
                                                                        <td colspan="5" class="text-center grey--text">{{ $t('clients.noAddresses') || 'Nenhum endereço cadastrado.' }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </template>
                                                        </v-simple-table>
                                                    </v-radio-group>
                                                    <v-btn color="primary" small class="mb-2" @click="openAddAddressDialog">
                                                        <v-icon left small>mdi-plus</v-icon>
                                                        {{ $t('clients.addAddress') || 'Adicionar endereço' }}
                                                    </v-btn>

                                                    <v-dialog v-model="dialogEndereco" max-width="900" persistent >
                                                        <v-card>
                                                            <v-toolbar dark color="primary" dense>
                                                                <v-btn icon dark @click="closeAddAddressDialog"><v-icon>mdi-close</v-icon></v-btn>
                                                                <v-toolbar-title>{{ $t('clients.addAddress') || 'Adicionar endereço' }}</v-toolbar-title>
                                                            </v-toolbar>
                                                            <v-card-text>
                                                                <v-form ref="formEndereco" v-model="formEnderecoValidado">
                                                                  <v-row class="mt-4">
                                                                    <v-col cols="12">
                                                                      <v-text-field v-model="editedEndereco.nome_local"
                                                                        :label="$t('clients.locationName') || 'Nome do local'" counter="200" clearable dense
                                                                        :placeholder="$t('clients.locationNamePlaceholder') || 'Ex.: Principal, Sede, Filial'">
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12">
                                                                      <v-checkbox v-model="editedEndereco.is_default" :label="$t('clients.setAsDefaultAddress') || 'Definir como endereço padrão'" hide-details dense />
                                                                    </v-col>
                                                                  </v-row>
                                                                  <v-row>
                                                                    <v-col cols="12" sm="6" md="4">
                                                                      <v-text-field v-model="editedEndereco.cep"
                                                                        :label="$t('address.postalCode')" counter="20" clearable dense
                                                                        :placeholder="$t('passengers.address.cepPlaceholder') || '00000-000'">
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="4">
                                                                      <v-text-field v-model="editedEndereco.estado"
                                                                        :label="$t('address.state')" counter="2" clearable dense>
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="4">
                                                                      <v-text-field v-model="editedEndereco.cidade"
                                                                        :label="$t('address.city')" counter="100" clearable dense>
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="4">
                                                                      <v-text-field v-model="editedEndereco.bairro"
                                                                        :label="$t('address.district')" counter="100" clearable dense>
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="5">
                                                                      <v-text-field v-model="editedEndereco.endereco"
                                                                        :label="$t('address.street')" counter="300" clearable dense
                                                                        prepend-icon="mdi-map-marker"
                                                                        :rules="[(v) => (v === null || v === undefined || !v.length || v.length <= 500) || $t('geofence.addressCharacterLimit')]">
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="2" md="1">
                                                                      <v-btn fab color="primary" dark small class="mb-2" @click="searchAddressFromMap"
                                                                        :loading="loadingEndereco" title="">
                                                                        <v-icon>mdi-map-search</v-icon>
                                                                      </v-btn>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="4" md="2">
                                                                      <v-text-field v-model="editedEndereco.numero"
                                                                        :label="$t('address.number')" counter="20" clearable dense>
                                                                      </v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="4">
                                                                      <v-text-field v-model="editedEndereco.complemento"
                                                                        :label="$t('address.complement')" counter="100" clearable dense>
                                                                      </v-text-field>
                                                                    </v-col>
                                                                  </v-row>
                                                                </v-form>
                                                                <v-lazy>
                                                                  <div id="address-map-container" class="address-map-container">
                                                                    <l-map ref="addressMap" :zoom="addressMapZoom" :center="addressMapCenter" :key="addressMapKey">
                                                                      <l-tile-layer :url="addressMapUrl" :attribution="addressMapAttribution" />
                                                                      <l-marker v-if="addressMarkerLatLng" :lat-lng="addressMarkerLatLng" />
                                                                    </l-map>
                                                                  </div>
                                                                </v-lazy>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn text @click="closeAddAddressDialog">{{ $t('button.cancel') }}</v-btn>
                                                                <v-btn color="primary" @click="saveNewAddress">{{ $t('button.save') }}</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<style scoped>
.address-map-container {
  width: 100%;
  height: 320px;
  margin-top: 16px;
  border-radius: 8px;
  overflow: hidden;
  z-index: 0;
}
</style>

<script>

    import axios from "axios";
    import apiController from "@/utils/apiController";
    import { GeoCodeBaseUrl, GeoCodeApiKey } from "@/constants";
    import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
    import "leaflet/dist/leaflet.css";
    import MerusDataTable from "./Tables/MerusDataTable.vue";
    import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
    import EventBus from "../utils/eventBus";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        clientes: [],
        displayedItemsForExport: null,
        empresas: [],
        mostrarInativos: false,
        search: "",
        loadingtable: true,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,
        authDialog: false,
        formValidado: true,
        dialog: false,
        sysError: null,
        editedIndex: -1,
        operacao: 0,
        editedItem: {
            id_cliente: null,
            codigo_cliente: null,
            nome_cliente: null,
            id_empresa: null,
            ativo: 1,
        },
        deletedItem: {
            id_cliente: null,
            codigo_cliente: null,
            nome_cliente: null,
            id_empresa: null,
            ativo: null,
        },
        defaultItem: {
            id_cliente: null,
            codigo_cliente: null,
            nome_cliente: null,
            id_empresa: null,
            ativo: 1,
        },
        locaisDoCliente: [],
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
        formEnderecoValidado: true,
        editedEndereco: {
            nome_local: null,
            is_default: false,
            id_pais: null,
            cep: null,
            estado: null,
            cidade: null,
            bairro: null,
            endereco: null,
            numero: null,
            complemento: null,
        },
        defaultEndereco: {
            nome_local: null,
            is_default: false,
            id_pais: null,
            cep: null,
            estado: null,
            cidade: null,
            bairro: null,
            endereco: null,
            numero: null,
            complemento: null,
        },
        dialogEndereco: false,
        pendingAddresses: [],
        _pendingAddressId: 0,
        loadingEndereco: false,
        addressMapUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        addressMapAttribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        addressMapCenter: [-22.951804, -43.21076],
        addressMapZoom: 14,
        addressMarkerLatLng: null,
        addressMapKey: 0,
        defaultLocalKey: null,
        defaultPendingId: null,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            if (this.$refs.formEndereco) {
                this.$refs.formEndereco.resetValidation();
            }
        },
        dialog(val) {
            if (val) {
                if (this.editedIndex === -1) {
                    this.locaisDoCliente = [];
                    this.pendingAddresses = [];
                    this.defaultLocalKey = null;
                    this.defaultPendingId = null;
                    this.editedEndereco = Object.assign({}, this.defaultEndereco);
                    this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
                }
                if (this.$refs.formEndereco) {
                    this.$refs.formEndereco.resetValidation();
                }
            }
        },
        empresas() {
            if (this.dialog && this.editedIndex === -1) {
                this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
            }
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    methods: {

        applySingleEmpresaIfOnlyOption() {
            if (!this.dialog || this.editedIndex !== -1) {
                return;
            }
            if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
                return;
            }
            if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
                return;
            }
            this.editedItem.id_empresa = this.empresas[0].id_empresa;
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatecliente");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertcliente");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletecliente");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            apiController.request(apiController.endpoints.getallClientes, {
                silent: true,
                onSuccess: (response) => {
                    this.clientes = response.data;
                    this.loadingtable = false;
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
            this.populaEmpresas();
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
            });
        },
        close() {
            this.dialog = false;
            this.dialogEndereco = false;
            this.locaisDoCliente = [];
            this.pendingAddresses = [];
            this.defaultLocalKey = null;
            this.defaultPendingId = null;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedEndereco = Object.assign({}, this.defaultEndereco);
                this.editedIndex = -1;
            });
        },
        formatAddressLine(local) {
            if (!local) return '—';
            const parts = [local.endereco, local.numero, local.complemento].filter(Boolean);
            const line1 = parts.join(', ');
            const parts2 = [local.bairro, local.cidade, local.estado].filter(Boolean);
            const line2 = parts2.join(' - ');
            return [line1, line2].filter(Boolean).join(' — ') || '—';
        },
        openAddAddressDialog() {
            this.editedEndereco = Object.assign({}, this.defaultEndereco);
            this.dialogEndereco = true;
            this.$nextTick(() => this.$refs.formEndereco && this.$refs.formEndereco.resetValidation());
        },
        searchAddressFromMap() {
            const parts = [
                this.editedEndereco.endereco,
                this.editedEndereco.numero,
                this.editedEndereco.bairro,
                this.editedEndereco.cidade,
                this.editedEndereco.estado,
                this.editedEndereco.cep
            ].filter(Boolean).map((s) => String(s).trim());
            const query = parts.length ? parts.join(', ') : (this.editedEndereco.endereco && this.editedEndereco.endereco.trim()) || null;
            if (!query) return;
            this.loadingEndereco = true;
            axios
                .get(GeoCodeBaseUrl +
                    encodeURIComponent(query) +
                    "&limit=1&types=address" +
                    "&access_token=" + GeoCodeApiKey)
                .then((response) => {
                    const features = response.data && response.data.features;
                    const feature = Array.isArray(features) && features[0];
                    const props = feature && feature.properties;
                    if (props) {
                        const fullAddress = props.full_address || query;
                        const ctx = props.context || {};
                        if (ctx.address) {
                            if (ctx.address.address_number) this.editedEndereco.numero = ctx.address.address_number;
                            if (ctx.address.street_name && !this.editedEndereco.endereco) this.editedEndereco.endereco = ctx.address.street_name;
                            if (ctx.address.name && !this.editedEndereco.endereco) this.editedEndereco.endereco = ctx.address.name;
                        }
                        if (!this.editedEndereco.endereco && ctx.street && ctx.street.name) this.editedEndereco.endereco = ctx.street.name;
                        if (ctx.region && ctx.region.region_code) this.editedEndereco.estado = ctx.region.region_code;
                        if (ctx.place && ctx.place.name) this.editedEndereco.cidade = ctx.place.name;
                        if (ctx.locality && ctx.locality.name && !this.editedEndereco.cidade) this.editedEndereco.cidade = ctx.locality.name;
                        if (ctx.neighborhood && ctx.neighborhood.name) this.editedEndereco.bairro = ctx.neighborhood.name;
                        if (ctx.postcode && ctx.postcode.name) this.editedEndereco.cep = ctx.postcode.name;
                        if (!this.editedEndereco.endereco) this.editedEndereco.endereco = fullAddress;
                        if (props.coordinates) {
                            const lat = props.coordinates.latitude;
                            const lng = props.coordinates.longitude;
                            this.addressMarkerLatLng = [lat, lng];
                            this.addressMapCenter = [lat, lng];
                            this.addressMapKey += 1;
                        }
                    } else if (Array.isArray(features) && features.length === 0) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('address.notPossibleGet') || 'Endereço não encontrado.', tipo: 'warning' });
                    }
                    this.loadingEndereco = false;
                })
                .catch((e) => {
                    this.loadingEndereco = false;
                    EventBus.$emit('show-error', { error: e });
                });
        },
        closeAddAddressDialog() {
            this.dialogEndereco = false;
            this.editedEndereco = Object.assign({}, this.defaultEndereco);
            this.addressMarkerLatLng = null;
            this.addressMapCenter = [-22.951804, -43.21076];
        },
        saveNewAddress() {
            if (!this.$refs.formEndereco || !this.$refs.formEndereco.validate()) return;
            const nomeLocalStr = this.editedEndereco.nome_local ? String(this.editedEndereco.nome_local).trim() : null;
            const isDefault = !!this.editedEndereco.is_default;
            const payload = {
                nome_local: nomeLocalStr || 'Principal',
                endereco: this.editedEndereco.endereco ? String(this.editedEndereco.endereco).trim() : null,
                cep: this.editedEndereco.cep ? String(this.editedEndereco.cep).trim() : null,
                numero: this.editedEndereco.numero ? String(this.editedEndereco.numero).trim() : null,
                complemento: this.editedEndereco.complemento ? String(this.editedEndereco.complemento).trim() : null,
                estado: this.editedEndereco.estado ? String(this.editedEndereco.estado).trim() : null,
                cidade: this.editedEndereco.cidade ? String(this.editedEndereco.cidade).trim() : null,
                bairro: this.editedEndereco.bairro ? String(this.editedEndereco.bairro).trim() : null,
                id_pais: this.editedEndereco.id_pais || null,
                ativo: 1,
                is_default: isDefault,
            };
            if (this.editedIndex === -1) {
                this._pendingAddressId += 1;
                const pendingId = 'pending-' + this._pendingAddressId;
                this.pendingAddresses.push({ ...payload, _pendingId: pendingId });
                if (isDefault) {
                    this.defaultPendingId = pendingId;
                    this.defaultLocalKey = pendingId;
                }
                this.closeAddAddressDialog();
                return;
            }
            const idCliente = this.editedItem.id_cliente;
            if (!idCliente) return;
            apiController.request(apiController.endpoints.insertLocal, {
                data: { id_cliente: idCliente, ...payload },
                onSuccess: () => {
                    this.closeAddAddressDialog();
                    this.loadLocaisDoCliente(idCliente);
                },
            });
        },
        onDefaultAddressChange(key) {
            if (key == null) return;
            const local = this.addressesForTable.find((l) => (l.id_local || l._pendingId) === key);
            if (local) this.setDefaultLocal(local);
        },
        setDefaultLocal(local) {
            if (local._pendingId) {
                this.defaultPendingId = local._pendingId;
                this.defaultLocalKey = local._pendingId;
                return;
            }
            if (!local.id_local || !this.editedItem.id_cliente) return;
            apiController.request(apiController.endpoints.updateLocal, {
                params: { id: local.id_local },
                data: { is_default: 1 },
                onSuccess: () => this.loadLocaisDoCliente(this.editedItem.id_cliente),
            });
        },
        deactivateLocal(local) {
            if (local._pendingId) {
                this.pendingAddresses = this.pendingAddresses.filter((p) => p._pendingId !== local._pendingId);
                return;
            }
            if (!local.id_local) return;
            apiController.request(apiController.endpoints.updateLocal, {
                params: { id: local.id_local },
                data: { ativo: 0 },
                onSuccess: () => this.loadLocaisDoCliente(this.editedItem.id_cliente),
            });
        },
        loadLocaisDoCliente(idCliente) {
            if (!idCliente) {
                this.locaisDoCliente = [];
                return;
            }
            apiController.request(apiController.endpoints.getLocaisporcliente, {
                params: { id: idCliente },
                silent: true,
                onSuccess: (response) => {
                    this.locaisDoCliente = response.data || [];
                    const defaultOne = this.locaisDoCliente.find((l) => l.is_default === 1);
                    this.defaultLocalKey = defaultOne ? defaultOne.id_local : (this.locaisDoCliente[0] ? this.locaisDoCliente[0].id_local : null);
                },
                onError: () => {
                    this.locaisDoCliente = [];
                },
            });
        },
        editItem(item) {
            this.editedIndex = this.clientes.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
            this.operacao = 1;
            this.editedEndereco = Object.assign({}, this.defaultEndereco);
            this.dialog = true;
            this.loadLocaisDoCliente(item.id_cliente);
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('clients.deleteClient') + ` ${this.deletedItem.nome_cliente}?`
            this.messageConfirmButton = this.$t('button.delete');
            this.messageDismissButton = this.$t('button.cancel');
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteCliente, {
                data: this.deletedItem,
                onSuccess: (response) => {
                    this.updateTable(response.data.erro);
                    this.confirmDialog = false;
                },
                onError: () => {
                    this.confirmDialog = false;
                },
            });
        },
        async save(){
            this.$refs.form.validate();
            if (this.formValidado) {
                // Converte ativo para número (0 ou 1)
                const clienteData = {
                    ...this.editedItem,
                    ativo: this.editedItem.ativo ? 1 : 0
                };

                if (this.editedIndex == -1) {
                    this.operacao = 0;
                    try {
                        const response = await apiController.request(apiController.endpoints.insertCliente, { data: clienteData, silent: true });
                        if (response.data.erro) {
                            this.updateTable(true);
                            return;
                        }
                        try {
                            const r = await apiController.request(apiController.endpoints.getClientesporcodigo, { params: { id: this.editedItem.codigo_cliente }, silent: true });
                            const client = Array.isArray(r.data) ? r.data[0] : r.data;
                            const idCliente = client && client.id_cliente;
                            if (idCliente && this.pendingAddresses.length) {
                                await Promise.all(this.pendingAddresses.map((p) =>
                                    apiController.request(apiController.endpoints.insertLocal, {
                                        data: {
                                            id_cliente: idCliente,
                                            nome_local: p.nome_local || 'Principal',
                                            endereco: p.endereco || null,
                                            cep: p.cep || null,
                                            numero: p.numero || null,
                                            complemento: p.complemento || null,
                                            estado: p.estado || null,
                                            cidade: p.cidade || null,
                                            bairro: p.bairro || null,
                                            id_pais: p.id_pais || null,
                                            ativo: 1,
                                            is_default: p._pendingId === this.defaultPendingId ? 1 : 0,
                                        },
                                        silent: true,
                                    })
                                ));
                            }
                            this.updateTable(false);
                        } catch (e) {
                            EventBus.$emit('show-error', { error: e });
                            this.updateTable(false);
                        }
                    } catch (e) {
                        EventBus.$emit('show-error', { error: e });
                    }
                } else {
                    this.operacao = 1;
                    try {
                        const response = await apiController.request(apiController.endpoints.updateCliente, { data: clienteData, silent: true });
                        if (response.data.erro) {
                            this.updateTable(true);
                            return;
                        }
                        this.updateTable(false);
                    } catch (e) {
                        EventBus.$emit('show-error', { error: e });
                    }
                }
            }
        },
        updateTable(status) {
            let mensagem = "";
            let tipo = status ? "error" : "success";
            
            if (status) {
                if (this.operacao == 0) {
                    mensagem = this.$t('clients.alerts.error.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('clients.alerts.error.update');
                    } else {
                        mensagem = this.$t('clients.alerts.error.delete');
                    }
                }
            } else {
                if (this.operacao == 0) {
                    mensagem = this.$t('clients.alerts.success.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('clients.alerts.success.update');
                    } else {
                        mensagem = this.$t('clients.alerts.success.delete');
                    }
                }
            }
            
            EventBus.$emit('show-alert', { mensagem, tipo });
            this.close();
            this.initialize();
        },
    }
}
</script>

